import * as ko from 'knockout'
import {components, Subscribable} from 'knockout'
import ensureObservable from "../../util/ensure-observable";
import Config = components.Config;

interface ViewModelParams {
    label: string | Subscribable<string>;
    total: number | Subscribable<number>;
    value: number | Subscribable<number>;
    cssClass: string | Subscribable<string>
}

class ViewModel {

    /**
     * The label.
     */
    label: Subscribable<string>;

    /**
     * Total amount.
     */
    public total: Subscribable<number>;

    /**
     * Current value.
     * Might be an observable which get's updated by the parent view model using setInterval.
     */
    public value: Subscribable<number>;

    /**
     * Current percentage value.
     */
    public percentage: Subscribable<number>;

    /**
     * Current percentage css class,
     */
    public percentageCssClass: Subscribable<string>;

    /**
     * The user image css class.
     */
    public cssClass: Subscribable<string>

    /**
     * Constructor.
     *
     * @param params
     */
    constructor(private params: ViewModelParams) {
        this.label = ensureObservable(params.label);
        this.total = ensureObservable(params.total);
        this.value = ensureObservable(params.value);
        this.percentage = ko.pureComputed(() => {
            const percentage = Math.round(100 - (100 / this.total() * this.value()));
            return percentage > 0 ? percentage : 0;
        });
        this.percentageCssClass = ko.pureComputed(() => this.cssClass() + " p" + this.percentage());
        this.cssClass = ensureObservable(params.cssClass ? params.cssClass : "small");
    }
}

const component: Config = {
    viewModel: (params: ViewModelParams) => new ViewModel(params),
    template: <string>require('./countdown.html')
};

export default component;

if (!ko.components.isRegistered('countdown')) {
    ko.components.register('countdown', component)
}